
import React from 'react';
import Card from '../components/card';
import FormGroup from '../components/form-group';
import EtiquetaService from '../app/service/etiquetaService';
import { mensagemErro, mensagemSucesso } from '../components/toastr';
import ClipLoader from "react-spinners/ClipLoader";
import { AuthContext } from '../main/provedorAutenticacao';
import 'primeicons/primeicons.css';
import { disabledTime } from 'rsuite/esm/utils/dateUtils';

class GerarEtiquetaArquivamento extends React.Component {

    state = {
        tipoConsulta: '',
        numero: '',
        listaArquivamentos: [],
        dadosEmpresa: [],
        loading: false,
        disabled: false,
        imagemGerada: false,
        mensagemErroSpan: ''
    };

    

    constructor() {
        super();
        this.service = new EtiquetaService();
    }

    limpar = () => {
        this.setState({
            tipoConsulta: '',
            numero: '',
            dadosEmpresa: [],
            listaArquivamentos: [],
            imagemGerada: false,
            disabled: false
        });
    };


    limparProtocolo = async (item) => {
       this.setState((prevState) => ({
            listaArquivamentos: prevState.listaArquivamentos.filter((num) => num !== item)
        }));

    }

    adicionarArquivamento = () => {
            const { numero, listaArquivamentos } = this.state;
            /*
            if (!numero.trim()) {
                mensagemErro('Informe um número de arquivamento.');
                return;
            }
            */

            if(!numero.trim()) {
                    this.setState({
                        mensagemErroSpan: '❌ Informe um número de arquivamento.',
                        loading: false,
                        disabled: false,
                        adicionarDisabled: false
                    });
                    return;
                }

    
            if (listaArquivamentos.includes(numero.trim())) {
                mensagemErro('Este número já foi adicionado.');
                return;
            }

            if(numero.startsWith('422')) {
                    this.setState({
                        mensagemErroSpan: '❌ Número de protocolo inválido! Esse número corresponde a um número de NIRE que inicia com "422".',
                        loading: false,
                        disabled: false,
                        adicionarDisabled: false
                    });
                    return;
                }

    
            this.setState({
                listaArquivamentos: [...listaArquivamentos, numero.trim()],
                numero: ''
            }, () => mensagemSucesso('Número arquivamento adicionado com sucesso!'));
        };

    consultar = async () => {
        const { tipoConsulta, numero, listaArquivamentos} = this.state;

        // limpa mensagem anterior
        this.setState({ mensagemErroSpan: '' });

        if (!tipoConsulta) {
            this.setState({ mensagemErroSpan: '❌ Selecione o tipo de consulta.' });
            return;
        }

        this.setState({ loading: true, disabled: true, adicionarDisabled: false });

        try {
            if (tipoConsulta === 'NIRE') {
                if (!numero) {
                    this.setState({
                        mensagemErroSpan: '❌ Informe o número do NIRE.',
                        loading: false,
                        disabled: false,
                        adicionarDisabled: false
                    });
                    return;
                }

                // Verifica se o NIRE começa com "422"
                if (!numero.startsWith("422")) {
                    this.setState({
                        mensagemErroSpan: '❌ Número de NIRE inválido. Deve iniciar com "422".',
                        loading: false,
                        disabled: false,
                        adicionarDisabled: false
                    });
                    return;
                }

                const response = await this.service.consultarEmpresaPorNire(numero);
                const lista = Array.isArray(response.data) ? response.data : [response.data];
                this.setState({ dadosEmpresa: lista });

                if(lista.length === 0) {
                    console.log("Lista vazia");
                    this.setState({
                        mensagemErroSpan: '❌ Número de NIRE ' + '"' +numero+ '"' + ' não encontrado!',
                        loading: false,
                        disabled: false,
                        adicionarDisabled: false
                    });
                    return;
                }
            } 
            else if (tipoConsulta === 'ARQUIVAMENTO') {
                if (listaArquivamentos.length === 0) {
                    this.setState({
                        mensagemErroSpan: '❌ Adicione pelo menos um número de arquivamento antes de buscar.',
                        loading: false,
                        disabled: false,
                        adicionarDisabled: false
                    });
                    return;
                }
                
                const response = await this.service.consultarEmpresasPorArquivamentos(listaArquivamentos);
                const lista = Array.isArray(response) ? response : [response];

                this.setState({
                    dadosEmpresa: lista,
                    numero: '',
                    listaArquivamentos: []
                });
                
                if(lista.length === 0) {
                    console.log("Lista vazia");
                    this.setState({
                        mensagemErroSpan: '❌ Número de protocolo ' + '"' +listaArquivamentos+ '"' + ' não encontrado!',
                        loading: false,
                        disabled: false,
                        adicionarDisabled: false
                    });
                    return;
                }
                
            }
        } catch (erro) {
            console.error("Erro na consulta:", erro);
            this.setState({ mensagemErroSpan: '❌ Erro ao consultar empresa. Verifique o número informado.' });
        } finally {
            this.setState({ loading: false, disabled: false});
        }
    };

    gerar = async (item) => {
         const { tipoConsulta, dadosEmpresa } = this.state;

        // Caso tipoConsulta seja "ARQUIVAMENTO", gera para todos os protocolos da lista
        if (tipoConsulta === 'ARQUIVAMENTO') {
            if (!dadosEmpresa || dadosEmpresa.length === 0) {
                mensagemErro('Nenhum arquivamento encontrado para gerar etiquetas.');
                return;
            }

            this.setState({ loading: true, disabled: true });

            try {
                // Monta o payload conforme o backend espera
                const payload = dadosEmpresa.map(emp => ({
                    NR_PROTOCOLO: emp.NR_PROTOCOLO
                }));

                console.log("Enviando payload para geração (ARQUIVAMENTO):", payload);

                const response = await this.service.post('/gerar', payload, {
                    headers: { 'Content-Type': 'application/json' }
                });

                console.log("Resposta do backend (gerar etiqueta arquivamento):", response.data);
                mensagemSucesso('Etiquetas geradas com sucesso para todos os arquivamentos!');

                this.setState({
                    imagemGerada: true,
                    loading: false,
                    disabled: false
                });

            } catch (erro) {
                console.error("Erro ao gerar etiquetas de arquivamento:", erro);
                mensagemErro('Erro ao gerar etiquetas. Verifique os arquivamentos e tente novamente.');
                this.setState({ loading: false, disabled: false });
            }

            return;
        }


        if (!item || !item.NR_PROTOCOLO) {
            mensagemErro('Número de arquivamento não encontrado.');
            return;
        }

        this.setState({ loading: true, disabled: true });

        try {
            console.log("Enviando POST para gerar etiqueta com arquivamento:", item.NR_PROTOCOLO);

            const response = await this.service.gerarEtiqueta(item.NR_PROTOCOLO);
            console.log("Resposta do backend (gerar etiqueta):", response.data);

            mensagemSucesso(`Etiqueta gerada para o arquivamento ${item.NR_PROTOCOLO}!`);

            // Atualiza a tabela com o link do PDF

            //Homologação: "http://localhost:8080/api/etiqueta/consulta/download/etiquetas_protocolo.pdf"
            const novaLista = this.state.dadosEmpresa.map((empresa) => {
                if (empresa.NR_PROTOCOLO === item.NR_PROTOCOLO) {
                    return {
                        ...empresa,
                        etiqueta: "http://200.19.203.155:8081/consultaProcesso/api/etiqueta/consulta/download/etiquetas_protocolo.pdf"
                    };
                }
                return empresa;
            });

            this.setState({ dadosEmpresa: novaLista });

        } catch (erro) {
            console.error("Erro ao gerar etiqueta:", erro);
            mensagemErro('Erro ao gerar etiqueta.');
        } finally {
            this.setState({ loading: false, disabled: false });
        }
    };

  
    render() {
        const { tipoConsulta, numero, listaArquivamentos, dadosEmpresa, imagemGerada } = this.state;

        return (
            <form className='scala-form'>
                <Card title="Gerar Imagem">
                    <fieldset disabled={this.state.disabled}>
                        <div className="row ">
                            <div className="col-md-8 fildeset-form">
                                <div className="bs-component">
                                    <div className='card p-3 m-2'>
                                        <FormGroup label="Tipo de Consulta: *" htmlFor="inputTipo">
                                            <select
                                                id="inputTipo"
                                                className="form-control max-w-[300px] mt-1"
                                                value={tipoConsulta}
                                                onChange={e => this.setState({ tipoConsulta: e.target.value, numero: '', listaArquivamentos: [], dadosEmpresa: [], imagemGerada: false,  mensagemErroSpan: '' })}
                                            >
                                                <option value="">Selecione...</option>
                                                <option value="NIRE">NIRE</option>
                                                <option value="ARQUIVAMENTO">ARQUIVAMENTO</option>
                                            </select>
                                        </FormGroup>

                                        <FormGroup label={<label htmlFor="inputNumero" className="meu-estilo-label mt-3">{`Número ${tipoConsulta ? tipoConsulta : ''}: *`}</label>}>
                                            <div className="container-busca-etiquetas">
                                                <div className="col-md-5 mr-5">
                                                    <input
                                                        type="text"
                                                        id="inputNumero"
                                                        className="form-control max-w-[420px]"
                                                        value={numero}
                                                        onChange={e => this.setState({ numero: e.target.value })}
                                                        placeholder={`Digite o número ${tipoConsulta ? 'do ' + tipoConsulta : ''}`}
                                                    />
                                                </div>

                                                
                                                    { tipoConsulta === 'ARQUIVAMENTO' && (
                                                        <div className="col-md-2 mr-[-10px]">     
                                                            <button type="button" className="btn btn-success"  
                                                            // Limpa mensagem de erro antes de adicionar
                                                            onClick={() => { this.setState({ mensagemErroSpan: '' }); this.adicionarArquivamento()}}                                            
                                                            
                                                            >
                                                                <i className="pi pi-plus"></i> Incluir
                                                            </button>
                                                        </div>
                                                    )}

                                                    <div className="col-md-3">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary"                                                  
                                                            onClick={ () => {this.setState({ mensagemErroSpan: '' }); this.consultar()}}                                                 
                                                        >
                                                            <i className="pi pi-search"></i> Buscar
                                                        </button>
                                                    </div>

                                                

                                            </div>
                                                    <div className="col-md-9 mt-3">
                                                        <span style={{ color: 'red' }}>
                                                                {this.state.mensagemErroSpan}                
                                                        </span>
                                                    </div>                                         

                                        </FormGroup>
                                    </div>            

                                    {/* Lista de arquivamentos */}
                                    {tipoConsulta === 'ARQUIVAMENTO' && listaArquivamentos.length > 0 && (
                                        
                                        <div className="table-container max-h-[260px]" style={{ width: '100%' }} >
                                            <div className="table-scroll" >
                                                    <table id='example' className="display nowrap table-striped table-bordered mt-4" style={{ width: '100%' }}>
                                                        <thead style={{
                                                            backgroundColor: '#3f463e',
                                                            color: '#8cb862',
                                                            position: 'sticky',
                                                            top: 0,
                                                            zIndex: 2
                                                        }}>
                                                            <tr style={{ textAlign: "center"}}>
                                                                <th>PROTOCOLO</th>
                                                                <th>STATUS</th>
                                                                <th>REMOVER</th>
                                                            </tr>
                                                        </thead>


                                                        <tbody>
                                                            
                                                            {listaArquivamentos.map((num, index) => (
                                                            
                                                                <tr key={index}>
                                                                
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }} >{num}</td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }} ><i class="bi bi-check-circle-fill"></i></td>
                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }} >
                                                                        <button 
                                                                            type="button" onClick={() => this.limparProtocolo(num)}> <i class="bi bi-eraser-fill"></i> 
                                                                        </button>
                                                                    </td>                                                               
                                                                                                                            
                                                                </tr>

                                                            ))}
                                                        </tbody>
                                                        
                                                    </table>
                                                                  {/*<h5 className="mt-6" style={{ textDecoration: "none", border: "none"}}>Itens adicionados: {listaArquivamentos.length}</h5>*/}
                                                
                                                   {/*table-scroll*/}                     
                                            </div> 

                                              {/*table-container*/} 
                                        </div> 
                                        
                                    )}
                                    <h5 className="mt-4" style={{ textDecoration: "none", border: "none"}}>
                                        
                                        {listaArquivamentos.length === 0 ? (
                                            <span style={{ color: 'red', display: 'none'}}>
                                                Itens adicionados: {listaArquivamentos.length} 
                                            </span>                        
                                            ) : (
                                                <span style={{ color: 'green' }}>
                                                Itens adicionados: {listaArquivamentos.length} 
                                            </span> 
                                            )}
                                        </h5>

                                    <div className="text-center mt-3">
                                        <ClipLoader loading={this.state.loading} size={45} />
                                    </div>

                                    {dadosEmpresa.length > 0 && (
                                        <div className="table-container" style={{ width: '100%' }} >
                                            <div className="table-scroll" >
                                                <table id='example' className="display nowrap table-striped table-bordered" style={{ width: '100%' }}>
                                                    <thead style={{
                                                        backgroundColor: '#3f463e',
                                                        color: '#8cb862',
                                                        position: 'sticky',
                                                        top: 0,
                                                        zIndex: 2
                                                    }}>
                                                        <tr style={{ textAlign: "center"}}>
                                                            <th>NIRE</th>
                                                            <th>EMPRESA</th>
                                                            <th>ARQUIVAMENTO</th>
                                                            <th>PROTOCOLO</th>
                                                            <th style={{ textAlign: 'center' }}hidden={this.state.tipoConsulta === 'ARQUIVAMENTO'}>AÇÕES</th>
                                                            <th style={{ textAlign: 'center' }} hidden={this.state.tipoConsulta === 'ARQUIVAMENTO'}>ETIQUETA</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {dadosEmpresa.map((item, index) => (
                                                            <tr key={index}>
                                                                <td style={{ textAlign: "center", verticalAlign: "middle" }} >{item.NR_NIRE}</td>
                                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.EMPRESA}</td>
                                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.NR_ARQUIVAMENTO}</td>
                                                                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{item.NR_PROTOCOLO}</td>
                                                                <td style={{ textAlign: "center", verticalAlign: "middle" }} hidden={this.state.tipoConsulta === 'ARQUIVAMENTO'}>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={() => this.gerar(item)}
                                                                    >
                                                                        <i className="pi pi-undo"></i> Gerar
                                                                    </button>
                                                                </td>
                                                                <td style={{ textAlign: "center", verticalAlign: "middle" }} hidden={this.state.tipoConsulta === 'ARQUIVAMENTO'}>
                                                                    {item.etiqueta ? (
                                                                        <a
                                                                            href={item.etiqueta}
                                                                            target="_blank"
                                                                            rel="noopener noreferrer"
                                                                        >
                                                                            <i className="pi pi-file-pdf size-6 animate-bounce"
                                                                                style={{ fontSize: '1.5em', color: 'red' }}
                                                                            ></i>
                                                                        </a>
                                                                    ) : (
                                                                        <i className="pi pi-file-pdf"
                                                                            style={{ fontSize: '1.5em', color: '#ccc' }}
                                                                        ></i>
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    )}

                                    {/* Botões inferiores */}
                                    {dadosEmpresa.length > 0 && (
                                        <div className="row mt-3">
                                            <div className="col-md-6">
                                                <button
                                                    type="button"
                                                    className="btn btn-danger"
                                                    onClick={this.limpar}
                                                >
                                                    <i className="pi pi-times"></i> Limpar
                                                </button>
                                                <button type="button" className="btn btn-success ms-3" hidden={tipoConsulta === 'NIRE'} onClick={ () => {this.limpar(); this.gerar()}} >
                                                    <i className="pi pi-refresh"></i> Gerar
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                     {/* Seção Imagem Gerada */}
                                    {imagemGerada && (
                                        <div className="mt-4">
                                            <h6><strong>Imagem Gerada:*</strong></h6>
                                            <table className="table table-bordered mt-2">  
                                                <thead style={{
                                                    backgroundColor: '#3f463e',
                                                    color: '#8cb862',
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 2
                                                }}>
                                                    <tr style={{ textAlign: "center"}}>
                                                        <th style={{ width: "70%" }}>MENSAGEM</th>
                                                        <th>VISUALIZAR</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr> {/*Homologação: href="http://localhost:8080/api/etiqueta/consulta/download/etiquetas_protocolo.pdf"*/}
                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}><span style={{ color: 'green'}}>Imagem gerada com sucesso!</span></td>
                                                        <td style={{ textAlign: "center", verticalAlign: "middle" }}> 
                                                            <a
                                                                href="http://200.19.203.155:8081/consultaProcesso/api/etiqueta/consulta/download/etiquetas_protocolo.pdf"                                                                
                                                                target="_blank" 
                                                                rel="noopener noreferrer"
                                                             >
                                                                <i className="pi pi-file-pdf size-6 animate-bounce" style={{ fontSize: '1.5em', color: 'red' }}></i>
                                                            </a>
                                                        </td>
                                                    </tr>
                                                </tbody>

                                                
                                            </table> 
                                                <div className="col-md-6">
                                                    <button type="button" className="btn btn-danger" onClick={this.limpar}>
                                                            <i className="pi pi-times"></i> Limpar
                                                    </button>
                                                </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </fieldset>
                </Card>
            </form>
        );
    }
}

GerarEtiquetaArquivamento.contextType = AuthContext;

export default GerarEtiquetaArquivamento;